import { get, post, put, postFormData, destroy } from './fetch'

export const getSellerDrivers = (option) => {
  return get(`/api/seller/drivers/list?page=${option.activePage}&limit=${option.rowsPerPage}`, true);
}

export const inviteSellerDriver = (requestData) => {
  return post(`/api/seller/drivers/invite` , requestData , true);
}

export const acceptSellerDriverInvite = (requestData) => {
  return post(`/api/seller-driver/accept-invite` , requestData , true);
}
export const getDriverSellerDetails = () => {
  return get(`/api/seller-driver/seller`, true);
}

export const getDispatchedRequestsList = (option) => {
  return get(`/api/seller-driver/dispatched/request/list?page=${option.activePage}&limit=${option.rowsPerPage}`, true);
}

export const getDispatchedRequestsDetail = (scRequestID) => {
  return get(`/api/seller-driver/dispatched/request/${scRequestID}/detail`, true);
}

export const getActiveSellerDrivers = (scRequestID) => {
  return post(`/api/seller/drivers/active`, {scRequestID} ,true);
}

export const dispatchRequest = (dispatchRequestData) => {
  return post(`/api/seller/dispatch/request` , dispatchRequestData , true);
}

export const resendInviteLink = (sellerDriverID) => {
  return post(`/api/seller/driver/${sellerDriverID}/resend/link` , {} , true);
}

export const updateDispatchRequestStatus = (dispatchID, statusID) => {
  return post(`/api/dispatch/request/${dispatchID}/status/update`, {statusID}, true);
}